<template>
    <div class="orderCenter">
        <div class="orderCenter-top">
            <div class="top-item">我的门票</div>
            <div class="top-navs">
                <div v-for="(item, index) in navlist" :key="index" @click="getdata(item.id)" class="navs-item"
                    :class="item.id == navsindex ? 'active' : ''">
                    <div>{{ item.name }}</div>
                    <div class="borderBottom" :class="item.id == navsindex ? 'active' : ''"></div>
                </div>
            </div>
        </div>
        <div class="orderCenter-bottom">
            <div class="bottom-item" v-for="(item, index) in   datalist  " :key="index" :class="index != 0 ? 'active' : ''">
                <div class="bottom-title">
                    <div class="number">
                        <p v-if="item.orderId"> 订单编号：{{ item.orderId }}</p>
                        <!-- <p v-if="item.num" style="color: black;">团队</p>
                        <p v-if="! item.num" style="color: black;">散客</p> -->
                    </div>

                    <!-- ===HERE===老版 -->
                    <!-- <div
              class="details"
              @click="$router.push('/orderDetails/' + item.id)"
              v-if="item.status != 1"
            >
              查看详情>>
            </div> -->
                </div>
                <div class="bottom-center">
                    <div class="bottom-item-left">
                        <div class="bottom-item-left-title1">
                            {{ item.tourName }} -电子门票
                        </div>
                        <div class="bottom-item-left-title2">
                            门票时间：{{ item.appointDate }} {{ item.appointTimeStart }}-{{
                                item.appointTimeEnd
                            }}
                        </div>

                        <!-- ===HERE===老版 -->
                        <!-- <div class="bottom-item-left-title2">姓名：{{ item.name }}</div> -->
                    </div>
                </div>
                <div v-if="! item.num">
                    {{ item.name.slice(0, -1) }}
                </div>
                <div class="bottom-ticeket">
                    <div class="ticeket-right" v-if="item.status == 1">
                        <div class="cancel" @click="deleteshow = true;
                        deleteid = item;
                                                                ">
                            关闭订单
                        </div>
                        <div class="pay" @click=" gopay(item) ">立即付款</div>
                    </div>
                    <div class="ticeket-right">
                        <div class="cancel1" v-if=" item.status == 2 "
                            style="width: 0.9rem; margin-right: 0.1rem" @click="
                                deleteshow = true;
                                deleteid = item;
                            ">
                            取消
                        </div>
                        <div class="cancel1" v-if=" item.status == 2 && item.price != 0 && item.isReturn == 0 "
                            style="width: 0.9rem; margin-right: 0.1rem" @click="
                                deleteshow = true;
                                deleteid = item;
                            ">
                            退款
                        </div>
                        <div class="cancel1" v-if=" item.status == 2 " @click=" myma(item) " style="width: 1.2rem">
                            查看门票
                        </div>
                    </div>
                </div>
            </div>
            <div v-if=" datalist.length == 0 " class="nobottom">
                <img src="../assets/appointment.png" alt="" />
            </div>
            <div class="prompt">
                <p>温馨提示</p>
                <p>
                    1.请按景区入园规定，有序入园。
                </p>
                <p>
                    2.出游期间请践行文明旅游，遵守景区相关规定。
                </p>
                <p>
                    3.该电子门票仅限取票人使用，不得转让。
                </p>
                <p>4.该电子门票不含景区内收费景点、收费项目。</p>
                <p>
                    5.请关注景区人流预警，若达最大承载量，景区将实行限流，尽情谅解。
                </p>
                <p>谢谢理解和配合！</p>

            </div>
        </div>
        <el-dialog :visible.sync=" show " width="85%" :show-close=" false " class="el-dialog-code" @open=" showcode ">
            <div class="imageMa">
             
                <img :src="this.cover" width="100%" 
              
               />
                <img src="../assets/Dotted.png" width="100%"  />

                <div style="width: 100%; background-color: #fff;">
                    <div class="title">{{ myurl.tourName }}-电子门票</div>
                    <div id="qrCode" ref="qrcode" style="width: 150px; margin: 0 auto;padding-top: 10px; padding-bottom: 10px;"></div>
                </div>
                <div style="background-color: #fff; font-size: 0.16rem">
                    <span>{{ myurl.appointDate }}</span>
                    <span style="margin-left: 4px">{{ myurl.appointTimeStart }}-{{ myurl.appointTimeEnd }}</span>
                </div>
                <div style="font-size:14px;font-weight:200;background-color: #fff;">1.退出此页面后，可在码上游首页点击</div>
                <div  style="font-size:14px;font-weight:200;background-color: #fff;">【我的门票】， 即可查看或使用。</div>
                <div class="Stitle"> 2.该电子门票不含景区内收费景点和项目。</div>
                <div class="cancel">
                    <div class="cancel-inner" @click=" show = false ">关闭</div>
                </div>
            </div>
            <!-- <div class="imageMa" v-else>
          <div class="title">{{ myurl.tourName }}</div>
          <img src="../assets/Dotted.png" width="100%" />
          <div class="prompt">
            <p>未注册随申码及</p>
            <p>当日新注册随申码用户</p>
            <p style="margin-top: 0.3rem">
              请出示<span style="color: red">随申码</span>入园
            </p>
          </div>
          <div class="cancel">
            <div class="cancel-inner" @click="show = false">关闭</div>
          </div>
        </div> -->
            <!-- <div class="heng">
                <div id="qrCode" ref="qrcode" width="80%"></div>
            </div> -->
        </el-dialog>
        <el-dialog :visible.sync=" deleteshow " width="70%" :show-close=" false " :close-on-click-modal=" false "
            class="el-dialog-centent">
            <div class="pull-con">
                <div class="pull-con-title1">温馨提示</div>
                <div class="pull-con-title2">确认取消订单?</div>
                <div class="pull-button">
                    <div @click=" deleteshow = false " style="background-color: rgba(44, 114, 114, 0.3); color: #2c7272">
                        取消
                    </div>
                    <div @click=" cancel " style="background-color: #2c7272; color: #fff">
                        确定
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Qrcode from "qrcodejs2"
export default {
    data() {
        return {
            //订单列表状态
            navlist: [
                // {
                //     name: "待付款",
                //     id: 1,
                // },
                {
                    name: "已取票",
                    id: 2,
                },
                {
                    name: "已使用",
                    id: 3,
                },
                // {
                //     name: "已退款",
                //     id: 4,
                // },
                {
                    name: "已过期",
                    id: 5,
                },
            ],
            //默认订单列表状态状态
            navsindex: 2,
            code: "",
            //当前状态订单
            datalist: [],
            cover:"",
            //门票码
            myurl: {code:""},
            show: false,
            //关闭订单
            deleteshow: false,
            deleteid: "",
        };
    },
    watch: {
        show(val) {
            if (val) {
                if (window.history && window.history.pushState) {
                    history.pushState(null, null, document.URL);
                    window.addEventListener("popstate", this.refreshFn, false); //false阻止默认事件
                }
            } else {
                this.myurl = "";
                window.history.back();
            }
        },
    },
    created() {
        this.navsindex = Math.floor(this.$route.query.status) || 2;

        this.getdata(this.navsindex);
        this.code = this.$route.query.code;
       
      
    },
    
    mounted(){

    this.create(  );
                  
    },
    methods: {
        create(){
          
        console.log(this.datalist);

        },
        //获取订单列表
        getdata(id) {
            this.navsindex = id;
            if (this.navsindex == 2) {
                this.$axios.get("/book/appointmentInfos?status=" + id).then((res) => {
                    this.datalist = res.data.rows;
                    this.$nextTick(function () {
                    if(this.code){
                    this.myurl = this.datalist.filter((item) => item.code == this.code)[0]
                    this.myma(this.myurl);
                   }
                   console.log(this.myurl);

                    
                }
                )
                })
                // this.$axios.get("/book/appointmentInfos?status=6").then((res) => {
                //     this.datalist = [...this.datalist, ...res.data.rows];
                // });
            } else {
                this.$axios.get("/book/appointmentInfos?status=" + id).then((res) => {
                    this.datalist = res.data.rows;
                });

            }
        },
        //预览二维码
        myma(url) {
            this.myurl = url;
            this.show = true;
        },
        showcode() {
            console.log(this.myurl);
            this.$axios
          .get(`/book/tourInfo/${this.myurl.tourId}`)
          .then((res) => {
            this.cover = res.data.bookTour.cover;


          })
            if (document.getElementById('qrCode')) {
                document.getElementById('qrCode').innerHTML = '';
            }

            this.$nextTick(function () {
                setTimeout(() => {
                    new Qrcode(this.$refs.qrcode, {
                        // text 需要转二维码的内容 可以是文本也可以是一个链接 是链接会直接跳走
                        text: this.myurl.code,
                        width: 150,
                         height: 150,
                        // colorDark: '#333',//二维码颜色
                        // colorLight: '#fff',//二维码背景颜色
                        correctLevel: Qrcode.CorrectLevel.L//容错率,L/M/H
                    })
                }, 500)
            });
        },
        cancel() {
            this.deleteshow = false;
            console.log(this.deleteid);
            this.$axios
                .get(
                    "/order/refundApply?orderId=" +
                    this.deleteid.orderId +
                    "&orderDetailId=" +
                    this.deleteid.id
                )
                .then((res) => {
                    if (res.code == 200) {
                        if (this.deleteid.price == 0) {
                            this.$message.success("取消门票成功");
                            // this.$router.push("/newOrderCenter");
                            this.code = null;
                            this.getdata(this.navsindex);
                        } else {
                            this.$message.success("退款申请提交成功");
                            this.getdata(this.navsindex);
                        }
                    } else {
                        if (this.deleteid.price == 0) {
                            this.$message.error("取消门票失败");
                        } else {
                            this.$message.error("退款申请提交成功");
                        }
                    }
                });
        },
        gopay(item) {
            this.$axios
                .post("/order/pay", {
                    orderId: item.orderId,
                    otaOrderDetailDTOs: [
                        {
                            id: item.id,
                        },
                    ],
                })
                .then((res) => {
                    if (res.code == 200) {
                        window.WeixinJSBridge.invoke(
                            "getBrandWCPayRequest",
                            {
                                appId: res.data.appId,
                                timeStamp: res.data.timeStamp.toString(),
                                nonceStr: res.data.nonceStr,
                                package: res.data.package,
                                signType: res.data.signType,
                                paySign: res.data.paySign,
                            },
                            (res) => {
                                if (res.err_msg == "get_brand_wcpay_request:ok") {
                                    this.getdata(2);
                                }
                            }
                        );
                    }
                    console.log(res);
                });
        },
        refreshFn() {
            if (this.show) {
                history.pushState(null, null, document.URL);
                this.show = false;
            }
        },
        getURL(data) {
            if (this.$route.query.id) {
                for (const iterator of data) {
                    if (iterator.id == this.$route.query.id) {
                        this.myma(iterator);
                        break;
                    }
                }
            }
        },
    },
    destroyed() {
        window.removeEventListener("popstate", this.refreshFn, false); //false阻止默认事件
    },
};
</script>
<style>
.el-dialog-centent {
    display: flex;
    align-items: center;
    justify-content: center;
}

.el-dialog-code {
    display: flex;
    align-items: center;
    justify-content: center;
}

.el-dialog-code .el-dialog {
    background-color: transparent;
}

.el-dialog-code .el-dialog__body {
    padding: 0;
}

.el-dialog {
    margin: 0 0 !important;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.el-dialog__header {
    display: none;
}
</style>
<style  lang="less" scoped>
.orderCenter {
    font-size: 0.16rem;

    .orderCenter-top {
        width: 100%;
        background-color: #2c7272;
        padding: 0 0.2rem;
        box-sizing: border-box;

        .top-item {
            font-size: 0.22rem;
            color: #fff;
            padding-top: 0.3rem;
        }

        .top-navs {
            display: flex;
            justify-content: space-between;
            align-items: center;
            // width: 100%;
            margin-top: 0.2rem;
            padding-bottom: 0.4rem;
            overflow-y: scroll;

            .navs-item {
                color: rgba(255, 255, 255, 0.8);
                flex-direction: 0;
                // width: 25%;
                font-size: 0.16rem;
                text-align: center;

                .borderBottom {
                    width: 0.35rem;
                    height: 0.03rem;
                    background-color: transparent;
                    margin: 0 auto;
                    margin-top: 0.05rem;
                }

                .active {
                    background-color: #fff;
                }
            }

            .active {
                color: #fff;
            }
        }
    }

    .orderCenter-bottom {
        background-color: #fff;
        border-top-left-radius: 0.15rem;
        border-top-right-radius: 0.15rem;
        position: relative;
        top: -0.2rem;
        padding: 0.1rem 0.2rem 0 0.2rem;
        box-sizing: border-box;

        .bottom-item {
            margin-bottom: 0.2rem;
            padding: 0.2rem 0 0.1rem 0;

            .bottom-title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 0.1rem;
                font-weight: 900;

                .number {
                    font-size: 0.13rem;
                    color: rgba(66, 66, 66, 0.5);
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                }

                .details {
                    color: #2c7272;
                }
            }

            .bottom-center {
                display: flex;
                justify-content: space-between;

                .bottom-item-left {
                    width: 100%;

                    .bottom-item-left-title1 {
                        color: #142323;
                        font-size: 0.2rem;
                        margin-bottom: 0.1rem;
                        font-weight: 600;
                    }

                    .bottom-item-left-title2 {
                        color: #868686;
                        font-size: 0.15rem;
                        margin-bottom: 0.07rem;
                    }
                }

                .ma {
                    text-align: center;

                    img {
                        width: 0.7rem;
                        height: 0.7rem;
                    }
                }
            }

            .bottom-ticeket {
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                margin-top: 0.1rem;

                .ticeket-left {
                    font-size: 0.18rem;
                    font-weight: 600;
                    line-height: 0.25rem;
                }

                .ticeket-right {
                    display: flex;

                    div {
                        border-radius: 0.3rem;
                        width: 0.85rem;
                        text-align: center;
                        font-size: 0.12rem;
                        line-height: 0.25rem;
                    }

                    .cancel {
                        border: 1px solid #2c7272;
                        color: #2c7272;
                        margin-right: 0.05rem;
                    }

                    .cancel1 {
                        background-color: rgba(44, 114, 114, 0.2);
                        color: #2c7272;
                        line-height: 0.35rem;
                        text-align: center;
                        border-radius: 0.05rem;
                        margin-top: 0.1rem;
                        font-size: 0.15rem;
                        font-weight: 700;
                    }

                    .pay {
                        background-color: #2c7272;
                        color: #fff;
                    }
                }
            }
        }

        .nobottom {
            width: 100%;

            img {
                width: 100%;
            }
        }

        .active {
            border-top: 1px solid #ccc;
        }

        .prompt {
            font-size: 0.1rem;
            color: #a0a0a0;
            margin-top: 0.3rem;
            line-height: 0.18rem;
        }
    }

    .pull {
        position: fixed;
        max-width: 768px;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .pull-con {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .pull-con-title1 {
            font-weight: 500;
            color: #142323;
            letter-spacing: 1px;
            font-size: 0.2rem;
            font-weight: 600;
            text-align: center;
        }

        .pull-con-title2 {
            margin-top: 0.2rem;
            font-size: 0.12rem;

            p {
                margin-bottom: 0.1rem;
                color: #142323;
                letter-spacing: 2px;
            }
        }

        .pull-button {
            width: 100%;
            line-height: 0.31rem;
            margin-top: 0.2rem;
            display: flex;
            justify-content: space-between;
            text-align: center;

            div {
                width: 40%;
                border-radius: 0.04rem;
            }
        }
    }
}

.imageMa {
    width: 100%;
    color: #535561;
    text-align: center;
    // bottom: -164px;
    // position: absolute;
    img {  
        display: block;
        margin: 0 auto;
    }

    .title {
        font-size: 0.24rem;
        background-color: #fff;
        border-top-left-radius: 0.13rem;
        border-top-right-radius: 0.13rem;
    
    }

    .prompt {
        font-size: 0.22rem;
        background-color: #fff;
        color: #000;
        font-weight: 600;
        padding: 0.4rem 0 1rem 0;
        border-bottom-left-radius: 0.13rem;
        border-bottom-right-radius: 0.13rem;
        height: 1.5rem;
        letter-spacing: 0.03rem;

        p {
            line-height: 0.3rem;
        }
    }

    .Stitle {
        font-size: 14px;
        background-color: #fff;
        padding-bottom: 0.2rem;
        border-bottom-left-radius: 0.13rem;
        border-bottom-right-radius: 0.13rem;
        font-weight: 200;
      //  padding-top: 0.1rem;
    }

    .cancel {
        width: 100%;
        position: absolute;

        .cancel-inner {
            border: 1px solid #fff;
            color: #fff;
            // padding: 0.15rem 0.4rem;
            width: 1.1rem;
            line-height: 0.4rem;
            border-radius: 0.3rem;
            font-size: 0.18rem;
            margin: 0.15rem auto;
        }
    }
}

.heng {
    width: 100%;
    display: flex;
    justify-content: center;

    img {
        height: 1rem;
    }
}

@media all and (orientation: landscape) {
    .imageMa {
        display: none;
    }
}

@media all and (orientation: portrait) {
    .heng {
        display: none;
    }
}
</style>